export default __webpack_public_path__ + "static/media/IMG_1770.249ed8cd.PNG";